import { post } from '@/utils/request'

/**
 * 多麦美团外卖信息
 */
export default function taoke_duomai_meituan_info() {
  return post('taoke_duomai_meituan_info')
}